import { createSlice } from "@reduxjs/toolkit";
import { dashboardInitialState } from "../initialState";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: dashboardInitialState,
  reducers: {
    // User Data Actions
    fetchUserDataStart: function(state) {
      state.loading.userData = true;
      state.errors.userData = null;
    },
    fetchUserDataSuccess: function(state, action) {
      state.userData = action.payload;
      state.loading.userData = false;
      state.errors.userData = null;
      state.lastFetched.userData = Date.now();
    },
    fetchUserDataFail: function(state, action) {
      state.loading.userData = false;
      state.errors.userData = action.payload;
    },

    // Matches Actions
    fetchMatchesStart: function(state) {
      state.loading.matches = true;
      state.errors.matches = null;
    },
    fetchMatchesSuccess: function(state, action) {
      state.matches = action.payload;
      state.loading.matches = false;
      state.errors.matches = null;
      state.lastFetched.matches = Date.now();
    },
    fetchMatchesFail: function(state, action) {
      state.loading.matches = false;
      state.errors.matches = action.payload;
    },

    // Reset dashboard
    resetDashboard: function(state) {
      state.userData = dashboardInitialState.userData;
      state.matches = [];
      state.loading = dashboardInitialState.loading;
      state.errors = dashboardInitialState.errors;
      state.lastFetched = dashboardInitialState.lastFetched;
    },
  },
});

export default dashboardSlice.reducer;
export const dashboardActions = dashboardSlice.actions;